import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable} from 'rxjs';
import {GridGetService, GridServiceParams, GridServiceResponse} from 'src/app/shared/model/page-grid';
import {removeEmptyParams} from 'src/infrastructure/helper/remove-empty-params';
import {getAutocompleteValue} from 'src/infrastructure/helper/autocomplete-helper';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class TransactionBookingGridService implements GridGetService<any> {
  private readonly baseUrl = 'transaction-booking/search';
  private readonly http = inject(HttpClient);

  getItems({filters, page, sort} : GridServiceParams): Observable<GridServiceResponse<any>>  {

    const params:Record<string, string | number | boolean> = {
      pageSize:  page?.pageSize || 25,
      pageNumber : (page?.pageIndex || 0) + 1,
      propertyName: sort?.active || '',
      orderKey: sort?.direction || '',

      bookingStatusName: filters?.['bookingStatusName'] ?? '',
      serviceStatusName: filters?.['serviceStatusName'] ?? '',
      bookingStartFrom: filters?.['bookingStartFrom'] ? moment(filters?.['bookingStartFrom']).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
      bookingStartTo: filters?.['bookingStartTo'] ? moment(filters?.['bookingStartTo']).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
      bookingEndFrom: filters?.['bookingEndFrom'] ? moment(filters?.['bookingEndFrom']).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
      bookingEndTo: filters?.['bookingEndTo'] ? moment(filters?.['bookingEndTo']).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
      dateCreatedFrom: filters?.['dateCreatedFrom'] ? moment(filters?.['dateCreatedFrom']).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
      dateCreatedTo: filters?.['dateCreatedTo'] ? moment(filters?.['dateCreatedTo']).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]') : '',
      agentName: getAutocompleteValue(filters?.['agentName']),
      bookingName: getAutocompleteValue(filters?.['bookingName']),
      externalNumber: getAutocompleteValue(filters?.['externalNumber']),
      tripReference: getAutocompleteValue(filters?.['tripReference']),
    };


    removeEmptyParams(params);

    return this.http.get<GridServiceResponse<any>>(`${this.baseUrl}`, { params: {...params} })
    .pipe(catchError((error:HttpErrorResponse)=>{
        throw new Error(error?.message || 'Server error');
    }));
  }
}
